import { ListHeader } from '@/components/List'

import { Actions } from './components/Actions'
import { Sorter } from './components/Sorter'
import { Filter } from './components/Filter'
import { Title } from './components/Title'

export function Header() {
  return (
    <ListHeader actions={<Actions />} title={<Title />} sorter={<Sorter />} filter={<Filter />} />
  )
}
